import React from 'react';
import Chip from '../../tcn/ui-kit/Chip';

/**
 * TierChip — tiny pill showing "T<n>". Color depends on tier height:
 *   - T1-3 → cyan
 *   - T4-6 → amber
 *   - T7-9 → magenta
 *   - T10  → diamond (top)
 */
const colorForTier = (tier) => {
  if (!tier || tier < 1) return 'cyan';
  if (tier <= 3) return 'cyan';
  if (tier <= 6) return 'amber';
  if (tier <= 9) return 'magenta';
  return 'diamond';
};

const TierChip = ({ tier, size = 'sm', solid = false, ...rest }) => {
  if (!tier && tier !== 0) return null;
  return (
    <Chip color={colorForTier(tier)} size={size} solid={solid} {...rest}>
      {`T${tier}`}
    </Chip>
  );
};

export default TierChip;
